/**
 * Shared constants for Google Maps address component type parsing.
 * These constants ensure consistency across different Google Maps API implementations
 * (Geocoder API vs Places Autocomplete API).
 */

export const STREET_NUMBER_TYPE = 'street_number';
export const STREET_TYPES: ReadonlyArray<string> = ['street_address', 'route'];
export const ZIP_TYPE = 'postal_code';
export const STATE_TYPE = 'administrative_area_level_1';

export const CITY_TYPES: ReadonlyArray<string> = [
  'neighborhood',
  'locality',
  'sublocality',
  'sublocality_level_1',
  'sublocality_level_2',
  'sublocality_level_3',
  'sublocality_level_4',
  'administrative_area_level_5',
  'administrative_area_level_4',
  'administrative_area_level_3',
];
